<div *ngIf="saga?.plan" class="plan">
  <mat-card class="plan__card" appearance="outlined">
    <mat-card-title>
      {{ plan.name }}
    </mat-card-title>
    <mat-card-subtitle>
      {{ plan.description }}
    </mat-card-subtitle>

    <mat-card-content>
      <div class="plan__features">
        <ul>
          <li class="plan__feature" *ngFor="let feature of plan.features">{{feature}}</li>
        </ul>
      </div>
      <div *ngIf="bundledFeatures()" class="plan__bundleditems">
        <div class="bundled-item-title">Features included</div>
        <ul>
          <li *ngFor="let feature of bundledFeatures()">{{feature}}</li>
        </ul>
      </div>
      <div *ngIf="plan.bundled_courses && plan.bundled_courses.length" class="plan__bundleditems">
        <div class="bundled-item-title">College courses included</div>
        <ul>
          <li *ngFor="let course of plan.bundled_courses">{{course.name}}</li>
        </ul>
      </div>
      <div class="plan__contract">
        <h2>Contract information</h2>
        <mat-tab-group *ngIf="hasBillingPeriodDetails()">
          <mat-tab *ngFor="let detail of getBillingPeriodDetails()" label="{{getRenewalPeriodText(detail.period_type)}}">
            <div class="contract">
              <div class="contract__field">
                <div class="contract__key">
                  Plan start date
                </div>
                <div class="contract__value">
                  {{getStartDate()}}
                </div>
              </div>
              <div *ngIf="getNextRenewalDate(detail.period_type)" class="contract__field">
                <div class="contract__key">
                  Renews automatically on
                </div>
                <div class="contract__value">
                  Every year on {{getNextRenewalDate(detail.period_type)}}
                </div>
              </div>
              <div class="contract__field">
                <div class="contract__key">
                  Minimum contract duration
                </div>
                <div class="contract__value">
                  {{getMinimumContractDuration(detail.period_type)}} months
                </div>
              </div>
              <div class="contract__field">
                <div class="contract__key">
                  Cancellation notice time
                </div>
                <div class="contract__value">
                  {{getCancellationNoticeTime(detail.period_type)}} days
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
        <div *ngIf="!hasBillingPeriodDetails()" class="contract">
          <div class="contract__field">
            <div class="contract__key">
              Plan start date
            </div>
            <div class="contract__value">
              {{getStartDate()}}
            </div>
          </div>
          <div *ngIf="getNextRenewalDate()" class="contract__field">
            <div class="contract__key">
              Renews automatically on
            </div>
            <div class="contract__value">
              Every year on {{getNextRenewalDate()}}
            </div>
          </div>
          <div *ngIf="getMinimumContractDuration()" class="contract__field">
            <div class="contract__key">
              Minimum contract duration
            </div>
            <div class="contract__value">
              {{getMinimumContractDuration()}} months
            </div>
          </div>
          <div *ngIf="getCancellationNoticeTime()" class="contract__field">
            <div class="contract__key">
              Cancellation notice time
            </div>
            <div class="contract__value">
              {{getCancellationNoticeTime()}} days
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showPlanPricing()" class="plan__pricing">
        <h2>Pricing information</h2>
        <div class="o-flex o-flex--wrap o-flex--full o-flex--justify-space-around o-flex--gap plan__pricing__wrapper">
          <div
              *ngFor="let planPrice of getPlanPricing()"
              class="o-flex o-flex--column o-flex--full plan__price"
              [class.plan__price--selected]="planPrice.selected"
          >
            <div *ngIf="planPrice.discounted_price != null" class="plan__price__discountnote">
              {{getDiscountValue()}}
            </div>
            <div class="plan__price__name">
              {{planPrice.name}} 
            </div>
            <div *ngIf="planPrice.discounted_price != null" class="plan__price__price">
              <span class="plan__price__discount">
                {{planPrice.currency}} {{planPrice.price}}
              </span>
              <span class="plan__price__discounted">
                {{planPrice.currency}} {{planPrice.discounted_price}}
              </span>
            </div>
            <div *ngIf="planPrice.discounted_price != null" class="plan__price__fullpricedate">
              Full price applies from {{getDiscountEndDate(planPrice)}}
            </div>
            <div *ngIf="planPrice.discounted_price == null" class="plan__price__price">
              {{planPrice.currency}} {{planPrice.price}}
            </div>
            <div *ngIf="planPrice.period !== 'monthly'" class="plan__price__period">
              * billed {{planPrice.period}}
            </div>
            <div *ngIf="planPrice.monthlySaving" class="plan__price__monthlysaving">
              Save {{planPrice.monthlySaving}}% compared to monthly billing
            </div>
          </div>
        </div>
        <p *ngIf="isTaxableCountry()" class="plan__pricing__tax">
          NOTE: Tax is <em>not included</em> in the above prices
        </p>
        <!-- TODO: Additional tests info <p *ngIf="showDiscountInfo()" class="discount-note">
          {{getDiscountInfo()}}
        </p> -->
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="!saga?.plan" class="plan">
  <mat-card class="plan__card" appearance="outlined">
    <mat-card-title>New subscription</mat-card-title>
    <mat-card-subtitle>Please wait while we load the details of your subscription...</mat-card-subtitle>
    <mat-card-content>
      <div class="plan__contract">
        <h2>Contract information</h2>
        <div class="contract">
          <div class="contract__field">
            <div class="contract__key">Plan start date</div>
            <div class="contract__value"></div>
          </div>
          <div class="contract__field">
            <div class="contract__key">Renews automatically on</div>
            <div class="contract__value"></div>
          </div>
          <div class="contract__field">
            <div class="contract__key">Minimum contract duration</div>
            <div class="contract__value"></div>
          </div>
          <div class="contract__field">
            <div class="contract__key">Cancellation notice time</div>
            <div class="contract__value"></div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<figure class="plan__logo">
  <img alt="INSCYD Logo" src="../../../../assets/images/app-logo-header-dark-theme.png"/>
</figure>
